import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabaseClient';

/**
 * Usa un "slot" para traer el anuncio activo:
 * - enabled = true
 * - starts_at <= now
 * - (ends_at is null OR ends_at >= now)
 * - order: priority ASC, created_at DESC
 */
export default function AdSlotManaged({
  slot,
  small = false,
  className = '',
}) {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const nowIso = new Date().toISOString();
      const { data, error } = await supabase
        .from('ads')
        .select('*')
        .eq('slot', slot)
        .eq('enabled', true)
        .lte('starts_at', nowIso)
        .or('ends_at.is.null,ends_at.gte.' + nowIso) // ends_at null OR >= now
        .order('priority', { ascending: true })
        .order('created_at', { ascending: false })
        .limit(1);

      if (!mounted) return;
      if (!error && data && data[0]) setAd(data[0]);
      else setAd(null);
    })();
    return () => { mounted = false; };
  }, [slot]);

  if (!ad) return null;

  const height = small ? 'h-28' : 'h-40';
  const hasImg = !!ad.image_url;

  return (
    <a
      href={ad.href || '#'}
      target={ad.href ? '_blank' : undefined}
      rel={ad.href ? 'noreferrer noopener' : undefined}
      className={`block rounded-xl overflow-hidden border shadow-sm hover:shadow-md transition bg-white ${height} ${className}`}
      style={hasImg ? { backgroundImage: `url(${ad.image_url})`, backgroundSize: 'cover', backgroundPosition: 'center' } : undefined}
      aria-label={ad.title || 'Publicidad'}
      title={ad.title || 'Publicidad'}
    >
      {!hasImg ? (
        <div className="w-full h-full grid place-items-center text-gray-400 text-sm px-3 text-center">
          {ad.title || 'Publicidad'}
        </div>
      ) : (
        <div className="bg-black/40 text-white p-2 text-xs line-clamp-1">
          {ad.title || 'Publicidad'}
        </div>
      )}
    </a>
  );
}
